import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Filter from '../../UI/buttons/Filter';

const CandidateFilter = () => {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const status = query.get('filter');
  const [filter, setFilter] = useState(status ? status : '');
  const [t] = useTranslation();
  const filterList = [
    {
      title: t('IN_PROCESS_TITLE'),
      value: 'in-process',
      translation:'IN_PROCESS_TOOLTIP'
    },
    {
      title: t('ALL_CANDIDATES'),
      value: '',
      translation:'ALL_CANDIDATES_TOOLTIP'
    },
  ];
  const handleChange = (value: string) => {
    setFilter(value);
  };
  useEffect(() => {
    const query = new URLSearchParams(history.location.search);
    if (!filter) {
      query.delete('filter');
      history.push({ search: query.toString() });
    } else {
      query.set('filter', filter);
      history.push({ search: query.toString() });
    }
  }, [filter, history]);
  useEffect(() => {
    setFilter(status ? status : '');
  }, [status]);
  return <Filter onClick={handleChange} list={filterList} active={filter} />;
};

export default CandidateFilter;
